/**
 * `/site/domain` — **Domain** (C11, FR-A8 §2; FR-A3; T-1.20), **rewritten by
 * C24 item 16** ([ADR-0051](../../../../../docs/adr/0051-the-domain-is-cores-and-prodesk-only-adopts-one.md)).
 *
 * The owner, 2026-10-01:
 *
 * > *Domain are manage by core so no need to show text box or save button,
 * > here only platform console managed domain status, redirection to console,
 * > check status etc*
 *
 * Which was right, and had always been right: ProDesk sells no domains (spec
 * §9-12), binds none, and `DomainStep`'s own header has said *"Nothing here
 * binds a domain"* since Wave 1. What the screen nonetheless had was a **text
 * box** and a **Save** — ProDesk's own claim, `firm_profile.custom_domain`,
 * which the publish gate and the portal read. So the firm typed a hostname
 * here and separately bound one in the console, and the two could disagree.
 * They did: a typo produced a screen that said *no domain yet* beside the
 * hostname the firm had just typed, and never corrected itself.
 *
 * ## What it is now
 *
 * **No field and no Save.** The screen lists what core says is bound to this
 * firm and the firm picks:
 *
 * - **exactly one bound host** → adopted on the first read that finds it, and
 *   shown with its state, its DNS detail and *Check again*;
 * - **several** → a radio list. Picking saves; there is no separate Save;
 * - **none** → said plainly, with everything-else-works and a link to the
 *   console;
 * - **a host that was bound and is now revoked** → the claim is *not* silently
 *   dropped. Dropping one on a transient read failure would unpublish a firm's
 *   website, so it is cleared only by a successful read that does not contain
 *   it — and then the firm is told, not surprised.
 *
 * ## One card, on two screens (C27, UAT report #7)
 *
 * The list, the adoption and both reads now live in **`Firm/DomainStep`**, the
 * one card ADR-0051 §3 asked for, because onboarding's Domain step draws the
 * same thing — until C27 it still had a Hostname box beside it. This file is
 * the page around the card; `hostToAdopt` and `claimIsStale` are re-exported
 * from here so the rule stays where a reader of this screen looks for it.
 */

import { SETTINGS, useEvaluation } from '../../lib/access'
import { DomainStep } from '../Firm/DomainStep'
import { SettingsPage } from '../Firm/settings/SettingsPage'

export { claimIsStale, hostToAdopt } from '../Firm/DomainStep'

export function DomainSettings() {
  const { can } = useEvaluation()
  return (
    <SettingsPage
      back={{ to: '/site', label: 'Your website' }}
      title="Domain"
      description="The address your website and client portal live on. You bind it in the platform console; ProDesk uses what you bind."
    >
      <DomainStep editable={can(SETTINGS, 'can_update')} />
    </SettingsPage>
  )
}
